import {
  getVariableValue,
  stringifyVariableValue,
} from "@/shared/utils/resolve-tokens";
import {
  type PillDecorator,
  pillDisplayText,
  VARIABLE_PILL_REPEATABLE_CLASS,
} from "@/shared/utils/variable-pill";
import type { Repeatable } from "./types";

/**
 * Pill decorator for repeatable fields (`{{team.name}}`): the editor shows the
 * single authored instance bound to ROW 1, so the pill reads row 1's value and
 * its tooltip says which row of how many it stands for. `data` must already be
 * scoped for nested chains (see scope.ts) so `getVariableValue` finds the array.
 */
export const createRepeatablePillDecorator = (
  repeatables: Repeatable[],
  data?: Record<string, unknown> | null,
): PillDecorator => {
  const byKey = new Map(repeatables.map((r) => [r.key, r]));
  return (name) => {
    const group = byKey.get(name.split(".")[0]);
    if (!group) return undefined;
    const rows = data?.[group.key];
    const count = Array.isArray(rows) ? rows.length : group.predefined.length;
    const resolved = stringifyVariableValue(getVariableValue(data, name));
    return {
      text: pillDisplayText(name, resolved),
      title: `${group.name} · row 1 of ${count}`,
      className: VARIABLE_PILL_REPEATABLE_CLASS,
    };
  };
};
